.filesListWrapper {
  padding: 8px 16px;
  box-sizing: border-box;
  background-color: var(--vkui--color_background_content);
  flex-shrink: 0;
}

.list {
  display: flex;
  flex-flow: row nowrap;
  gap: 16px;
  padding-top: 10px;

  & .item {
    flex-grow: 0;
    flex-shrink: 0;
  }

  & > .item:last-child {
    margin-right: 16px;
  }
}
